import { request } from '@/shared/api/request'

export const generateContractXML = (params) => {
	return request({ url: 'contract/get/xml', method: 'GET', params })
}
